import Styles from './TransactionStatus.module.css'
import React from 'react'
import Colors from 'Theme/Colors'
import InfinityEnums from 'Enums/InfinityEnums'
import Fade from '@mui/material/Fade'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled as muiStyled } from '@mui/system'

const StyledTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: (props) => props.statusColor,
    color: Colors.white,
    fontSize: '0.875rem',
    fontFamily: 'ProximaNova',
    padding: '0.3rem',
    marginLeft: '0.313rem',
    alignSelf: 'center',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: Colors.TooltipArrow,
  },
}))

const TransactionStatus = ({ status }) => {
  let title = status
    ? InfinityEnums.TransactionStatus.REVERSED
    : InfinityEnums.TransactionStatus.NORMAL
  const handleTransactionStatusColor = (status) => {
    if (status) return Colors.TransactionStatus.Reversed
    else return Colors.TransactionStatus.Normal
  }
  return (
    <StyledTooltip
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 60 }}
      title={title}
      placement="right"
      color="red"
      statusColor={handleTransactionStatusColor(status)}
    >
      <div
        className={Styles.Status}
        style={{ backgroundColor: handleTransactionStatusColor(status) }}
      />
    </StyledTooltip>
  )
}

export default TransactionStatus
